// import React, { useState, useEffect } from 'react';
// import {
//   Box, Typography, Button, Container, Card, CardContent,
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   CircularProgress, Alert, Chip
// } from '@mui/material';
// import CheckIcon from '@mui/icons-material/Check';
// import StarIcon from '@mui/icons-material/Star';
// import axios from 'axios';
// import API_BASE_URL from '../config';
// import { getErrorMessage } from '../utils/apiError';

// const PREMIUM_FEATURES = [
//   'Unlimited profile field edits',
//   'Full search results with contact details',
//   'Complete family tree access',
//   'Photo gallery access',
//   'Comment on profiles',
//   'Lifetime access — no renewal',
// ];

// const FREE_FEATURES = [
//   'Basic profile (limited fields)',
//   'Limited search results',
//   'Basic family tree view',
//   'No gallery or comments',
// ];

// const FeatureItem = ({ text, included }) => (
//   <Box sx={{
//     display: 'flex',
//     alignItems: 'center',
//     gap: 1,
//     mb: 1,
//     opacity: included ? 1 : 0.5
//   }}>
//     <CheckIcon sx={{ color: included ? '#00a76f' : '#bdbdbd' }} />
//     <Typography variant="body2">{text}</Typography>
//   </Box>
// );

// const Upgrade = () => {

//   const userRole = localStorage.getItem('userRole');
//   const userId = localStorage.getItem('userId');
//   const isAdmin = String(userRole) === '1';

//   const storageKey = `isPremium_${userId}`;

//   const [isPremium, setIsPremium] = useState(
//     localStorage.getItem(storageKey) === 'true'
//   );

//   const [loading, setLoading] = useState(true);
//   const [paying, setPaying] = useState(false);
//   const [error, setError] = useState('');
//   const [successOpen, setSuccessOpen] = useState(false);

//   const isPremiumUser = isPremium || isAdmin;

//   useEffect(() => {
//     fetchPlanStatus();

//     const syncHandler = () => {
//       const latest = localStorage.getItem(storageKey) === 'true';
//       setIsPremium(latest);
//     };

//     window.addEventListener('goldpetals:access-refresh', syncHandler);

//     return () =>
//       window.removeEventListener('goldpetals:access-refresh', syncHandler);
//   }, [userId]);

//   // ✅ FINAL FIXED LOGIC
//   const fetchPlanStatus = async () => {
//     try {
//       const res = await axios.get(`${API_BASE_URL}/plan/status`, {
//         withCredentials: true
//       });

//       const isActivePremium =
//         res.data.plan === 'premium' &&
//         res.data.userPlan?.status === 'active';

//       // ✅ API is absolute truth: Update state and storage immediately
//       if (isActivePremium) {
//         setIsPremium(true);
//         localStorage.setItem(storageKey, 'true');
//       } else {
//         setIsPremium(false);
//         localStorage.setItem(storageKey, 'false');
//       }

//     } catch (err) {
//       console.error('Plan fetch error:', err);

//       // ✅ fallback to localStorage
//       const localPremium = localStorage.getItem(storageKey) === 'true';
//       setIsPremium(localPremium);

//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleUpgrade = async () => {
//     if (paying || isPremiumUser) return;

//     setError('');
//     setPaying(true);

//     try {
//       const orderRes = await axios.post(
//         `${API_BASE_URL}/create-order`,
//         {},
//         { withCredentials: true }
//       );

//       const { order_id, is_dummy } = orderRes.data;

//       if (is_dummy) {
//         setTimeout(async () => {
//           await axios.post(
//             `${API_BASE_URL}/verify-payment`,
//             { order_id, dummy: true },
//             { withCredentials: true }
//           );
          
//           // 100% Dynamic: Notify hook to refetch from API and disable modal triggers
//           window.dispatchEvent(new Event('planUpdated'));

//           setSuccessOpen(true);
//           setPaying(false); // ✅ FIXED
//         }, 1000);

//         return;
//       }

//     } catch (err) {
//       setError(getErrorMessage(err));
//       setPaying(false);
//     }
//   };

//   if (loading) {
//     return (
//       <Container sx={{ mt: 10, textAlign: 'center' }}>
//         <CircularProgress />
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="md" sx={{ py: 6 }}>

//       {/* HEADER */}
//       <Box textAlign="center" mb={5}>
//         <Typography variant="h4" fontWeight={700}>
//           Upgrade Your Plan
//         </Typography>

//         <Box mt={2}>
//           {isPremiumUser ? (
//             <Chip
//               icon={<StarIcon />}
//               label="Plan Activated ✅"
//               sx={{ bgcolor: '#00a76f', color: '#fff' }}
//             />
//           ) : (
//             <Chip
//               label="Free Plan"
//               variant="outlined"
//               sx={{ borderColor: '#ffa726', color: '#ffa726' }}
//             />
//           )}
//         </Box>
//       </Box>

//       {error && <Alert severity="error">{error}</Alert>}

//       {/* PLANS */}
//       <Box sx={{
//         display: 'grid',
//         gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
//         gap: 3
//       }}>

//         {/* FREE */}
//         <Card sx={{ opacity: isPremiumUser ? 0.5 : 1 }}>
//           <CardContent>
//             <Typography variant="h6">Free Plan</Typography>

//             {FREE_FEATURES.map((f, i) => (
//               <FeatureItem key={i} text={f} included={!isPremiumUser} />
//             ))}

//             {!isPremiumUser && (
//               <Chip label="Current Plan" size="small" sx={{ mt: 2 }} />
//             )}
//           </CardContent>
//         </Card>

//         {/* PREMIUM */}
//         <Card sx={{ border: '2px solid #1976d2' }}>
//           <CardContent>
//             <Typography variant="h6">Premium Plan</Typography>

//             {PREMIUM_FEATURES.map((f, i) => (
//               <FeatureItem key={i} text={f} included />
//             ))}

//             {isPremiumUser ? (
//               <Button
//                 fullWidth
//                 disabled
//                 startIcon={<CheckIcon />}
//                 sx={{
//                   mt: 2,
//                   bgcolor: '#00a76f !important',
//                   color: '#fff'
//                 }}
//               >
//                 Plan Activated
//               </Button>
//             ) : (
//               <Button
//                 fullWidth
//                 variant="contained"
//                 onClick={handleUpgrade}
//                 disabled={paying}
//                 sx={{ mt: 2 }}
//               >
//                 {paying ? <CircularProgress size={20} /> : 'Upgrade ₹500'}
//               </Button>
//             )}
//           </CardContent>
//         </Card>
//       </Box>

//       {/* SUCCESS */}
//       <Dialog open={successOpen}>
//         <DialogTitle>Payment Successful</DialogTitle>
//         <DialogContent>
//           <Typography>You are now Premium 🎉</Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setSuccessOpen(false)}>OK</Button>
//         </DialogActions>
//       </Dialog>

//     </Container>
//   );
// };

// export default Upgrade;


import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Button, Container, Card, CardContent,
  Dialog, DialogTitle, DialogContent, DialogActions,
  CircularProgress, Alert, Chip
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import StarIcon from '@mui/icons-material/Star';
import axios from 'axios';
import API_BASE_URL from '../config';
import { getErrorMessage } from '../utils/apiError';

const PREMIUM_FEATURES = [
  'Unlimited profile field edits',
  'Full search results with contact details',
  'Complete family tree access',
  'Photo gallery access',
  'Comment on profiles',
  'Lifetime access — no renewal',
];

const FREE_FEATURES = [
  'Basic profile (limited fields)',
  'Limited search results',
  'Basic family tree view',
  'No gallery or comments',
];

const FeatureItem = ({ text, included }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, opacity: included ? 1 : 0.5 }}>
    <CheckIcon sx={{ color: included ? '#00a76f' : '#bdbdbd' }} />
    <Typography variant="body2">{text}</Typography>
  </Box>
);

// ✅ Load Razorpay SDK
const loadRazorpay = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);

    const script = document.createElement('script');
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const Upgrade = (props) => {

  const userRole = localStorage.getItem('userRole');
  const userId = localStorage.getItem('userId');
  const isAdmin = String(userRole) === '1';

  const storageKey = `isPremium_${userId}`;

  const [isPremium, setIsPremium] = useState(
    localStorage.getItem(storageKey) === 'true'
  );

  const [loading, setLoading] = useState(true);
  const [paying, setPaying] = useState(false);
  const [error, setError] = useState('');
  const [successOpen, setSuccessOpen] = useState(false);

  const isPremiumUser = isPremium || isAdmin;

  useEffect(() => {
    fetchPlanStatus();

    const syncHandler = () => {
      const latest = localStorage.getItem(storageKey) === 'true';
      setIsPremium(latest);
    };

    window.addEventListener('goldpetals:access-refresh', syncHandler);

    return () =>
      window.removeEventListener('goldpetals:access-refresh', syncHandler);
  }, [userId]);

  const fetchPlanStatus = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/plan/status`, {
        withCredentials: true
      });

      const isActivePremium =
        res.data.plan === 'premium' &&
        res.data.userPlan?.status === 'active';

      if (isActivePremium) {
        setIsPremium(true);
        localStorage.setItem(storageKey, 'true');
      } else {
        setIsPremium(false);
        localStorage.setItem(storageKey, 'false');
      }

    } catch (err) {
      const localPremium = localStorage.getItem(storageKey) === 'true';
      setIsPremium(localPremium);
    } finally {
      setLoading(false);
    }
  };

  // ✅ REAL PAYMENT FIXED HERE
  const handleUpgrade = async () => {
    if (paying || isPremiumUser) return;

    setError('');
    setPaying(true);

    try {
      // STEP 1: Create order
      const orderRes = await axios.post(
        `${API_BASE_URL}/create-order`,
        {},
        { withCredentials: true }
      );

      const { order_id, amount, currency, key } = orderRes.data;

      // STEP 2: Load Razorpay
      const loaded = await loadRazorpay();

      if (!loaded) {
        setError("Razorpay SDK failed to load");
        setPaying(false);
        return;
      }

      // STEP 3: Open payment
      const options = {
        key,
        amount,
        currency,
        name: "Gold Petals",
        description: "Premium Plan",
        order_id,

        handler: async function (response) {
          try {
            await axios.post(
              `${API_BASE_URL}/verify-payment`,
              {
                order_id: response.razorpay_order_id,
                payment_id: response.razorpay_payment_id,
                signature: response.razorpay_signature,
              },
              { withCredentials: true }
            );

            if (userId) {
              localStorage.setItem(`isPremium_${userId}`, 'true');
            }
            window.dispatchEvent(new Event('planUpdated'));
            if (props.onSuccess) props.onSuccess();
            if (props.onClose) props.onClose();
            setSuccessOpen(true);
          } catch (err) {
            setError(getErrorMessage(err));
          } finally {
            setPaying(false);
          }
        },

        modal: {
          ondismiss: () => setPaying(false)
        },

        theme: {
          color: "#1976d2"
        }
      };

      const rzp = new window.Razorpay(options);

      rzp.on('payment.failed', () => {
        setError("Payment Failed");
        setPaying(false);
      });

      rzp.open();

    } catch (err) {
      setError(getErrorMessage(err));
      setPaying(false);
    }
  };

  if (loading) {
    return (
      <Container sx={{ mt: 10, textAlign: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>

      <Box textAlign="center" mb={5}>
        <Typography variant="h4" fontWeight={700}>
          Upgrade Your Plan
        </Typography>

        <Box mt={2}>
          {isPremiumUser ? (
            <Chip icon={<StarIcon />} label="Plan Activated ✅" sx={{ bgcolor: '#00a76f', color: '#fff' }} />
          ) : (
            <Chip label="Free Plan" variant="outlined" sx={{ borderColor: '#ffa726', color: '#ffa726' }} />
          )}
        </Box>
      </Box>

      {error && <Alert severity="error">{error}</Alert>}

      <Box sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
        gap: 3
      }}>

        <Card sx={{ opacity: isPremiumUser ? 0.5 : 1 }}>
          <CardContent>
            <Typography variant="h6">Free Plan</Typography>
            {FREE_FEATURES.map((f, i) => (
              <FeatureItem key={i} text={f} included={!isPremiumUser} />
            ))}
          </CardContent>
        </Card>

        <Card sx={{ border: '2px solid #1976d2' }}>
          <CardContent>
            <Typography variant="h6">Premium Plan</Typography>

            {PREMIUM_FEATURES.map((f, i) => (
              <FeatureItem key={i} text={f} included />
            ))}

            {isPremiumUser ? (
              <Button fullWidth disabled startIcon={<CheckIcon />} sx={{ mt: 2, bgcolor: '#00a76f !important', color: '#fff' }}>
                Plan Activated
              </Button>
            ) : (
              <Button fullWidth variant="contained" onClick={handleUpgrade} disabled={paying} sx={{ mt: 2 }}>
                {paying ? <CircularProgress size={20} /> : 'Upgrade ₹500'}
              </Button>
            )}
          </CardContent>
        </Card>
      </Box>

      <Dialog open={successOpen}>
        <DialogTitle>Payment Successful</DialogTitle>
        <DialogContent>
          <Typography>You are now Premium 🎉</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSuccessOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>

    </Container>
  );
};

export default Upgrade;